module.exports = __webpack_public_path__ + "assets/038b6dfe5ded093ec5e1b2ba9aef27af.png";